import { render, staticRenderFns } from "./tourTutorial.vue?vue&type=template&id=4386d70f"
import script from "./tourTutorial.vue?vue&type=script&lang=js"
export * from "./tourTutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports